import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const NotFound = () => {
  const { t } = useTranslation('common');
  const location = useLocation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-secondary">
      <div className="text-center">
        <h1 className="mb-4 text-display-md font-bold">404</h1>
        <p className="mb-4 text-xl text-secondary">{t('notFound.message')}</p>
        <a
          className="text-[var(--color-utility-blue-500)] underline hover:text-[var(--color-utility-blue-700)]"
          href="/"
        >
          {t('notFound.returnHome')}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
